import { getSystemSettings } from './SettingsRetriever';

import history from '../history';

export default (path, newTab) => {
    newTab
    ? window.open(getSystemSettings().urlPrefix + path)
    : history.push(getSystemSettings().urlPrefix + path);
}

